import { IonPage } from '@ionic/react';
import styled from 'styled-components';

import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAISecond/components/Title';

export const PageStyles = styled(IonPage)<{
  theme?: 'dark-violet' | 'domination' | 'purple-gradient';
  hasFixedTimer?: boolean;
}>`
  body.dark & {
    ion-content {
      --background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );
      background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );

      ${({ theme }) =>
        theme === 'dark-violet' &&
        `
        --background: #43285B;
        background: #43285B;
      `}
    }
  }

  ion-content {
    background: #fff;
    --background: #fff;
    --padding-top: 20px;

    &::part(scroll) {
      margin: 0 0;
      padding: 30px 0 0;

      ${({ hasFixedTimer }) => hasFixedTimer && 'margin: 72px 0 0;'}
    }
  }
`;

export const TitleStyles = styled(OwnAiTitle)`
  margin: 0 0 16px;
`;
